import { NavLink } from 'react-router-dom';

function DuplicateUsers({ duplicateUsers = [], loading }) {
  return (
    <div className="ant-list-box table-responsive" style={{ maxHeight: 400 }}>
      <table className="width-100">
        <thead>
          <tr>
            <th>User ID</th>
            <th>SSN Whitelisted</th>
          </tr>
        </thead>
        <tbody>
          {duplicateUsers && duplicateUsers.map((data) => {
            return (
              <tr key={data.value}>
                <td>
                  <NavLink to={`/user/${data.value}`}>
                    <span className="label" style={{ textDecoration: 'underline' }}>{data.value}</span>
                  </NavLink>
                  {/* <CustomText
                    dataSet={data}
                    property1={'value'}
                    isHyperLink={true}
                  /> */}
                </td>
                <td>
                  {data.isWhitelisted ? "True" : "False"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default DuplicateUsers;
